/*
 * Tip Jar WP
 * https://www.tipjarwp.com
 *
 * Licensed under the GPL license.
 *
 * Author: Tip Jar WP
 * Version: 1.0
 * Date: April 18, 2018
 */

window.Tip_Jar_WP_Note_Wall = class Tip_Jar_WP_Note_Wall extends React.Component {

	constructor( props ){
		super(props);

		this.state = {
			note_parent: false,
			note_key: false,
			note_to_update: false,
			notes: {},
			notes_per_page: 20,
			current_page: 1,
			reply_input_visible: false,
			unique_settings: {
				strings: tip_jar_wp_note_wall_vars.strings
			},
			frontend_nonces: tip_jar_wp_js_vars.frontend_nonces
		};

	}

	componentDidMount() {
		this.get_notes_from_server();

		document.addEventListener( 'tip_jar_wp_payent_completed', this.get_notes_from_server.bind( this ) );
	}

	set_note_reply_state( note_parent, note_key ) {
		this.setState( {
			note_parent: note_parent,
			note_key: note_key,
			note_to_update: false,
			reply_input_visible: true,
		}, () => {
			this.reply_input.focus();
		} );
	}

	completed_note_reply_state( new_note_from_server ) {

		// Inject the new note into the array of notes at the key spot.
		var new_notes_state = this.state.notes;

		new_notes_state = this.find_and_inject_new_note_in_state( new_notes_state, new_note_from_server );

		this.setState( {
			notes: new_notes_state,
			reply_input_visible: false,
		} );
	}

	find_and_inject_new_note_in_state( notes, new_note_from_server ) {
		for (var key in notes) {
			// If the parents match, this is a reply to that parent.
			if ( new_note_from_server.is_reply_to === notes[key].id ) {
				notes[key]['replies'].splice( notes[key]['replies'].length, 0, new_note_from_server );
				return notes;

				// If the parent do not match this is not a reply, but lets check if its a reply to a reply.
			} else {
				// If this parent has replies, check those replies to see if this is a reply to a reply.
				if ( notes[key]['replies'] ) {
					notes[key]['replies'] = this.find_and_inject_new_note_in_state( notes[key]['replies'], new_note_from_server );
				}
			}
		}

		return notes;
	}

	cancel_note_reply_state() {
		this.setState( {
			note_parent: false,
			note_key: false,
			note_to_update: false,
			reply_input_visible: false,
		} );
	}

	hande_note_update( event ) {
		this.setState( {
			note_content: event.target.value,
		} );
	}

	hande_note_submit() {

		return new Promise( (resolve, reject) => {

			if ( ! this.state.note_content ) {
				return false;
			}

			var postData = new FormData();
			postData.append('action', tip_jar_wp_note_wall_vars.add_or_update_note_endpoint );
			postData.append('note_id', this.state.note_to_update );
			postData.append('note_content', this.state.note_content );
			postData.append('is_reply_to', this.state.note_parent.id );
			postData.append('add_or_update_note_nonce', tip_jar_wp_note_wall_vars.add_or_update_note_nonce);

			fetch( tip_jar_wp_note_wall_vars.add_or_update_note_endpoint, {
				method: "POST",
				mode: "same-origin",
				credentials: "same-origin",
				body: postData
			} ).then(
				( response ) => {
					if ( response.status !== 200 ) {
						console.log('Looks like there was a problem. Status Code: ' + response.status);
						reject('unable_to_get_notes');
						return;
					}

					// Examine the text in the response
					response.json().then(
						( data ) => {
							if ( data.success ) {

								this.completed_note_reply_state( data.note );

							} else {
								console.log('Looks like there was a problem: ' + data);
								reject('unable_to_get_notes');
								return;
							}
						}
					).catch(
						( err ) => {
							console.log('Fetch Error: ', err);
							reject('unable_to_get_notes');
							return;
						}
					);
				}
			).catch(
				( err ) => {
					console.log('Fetch Error: ', err);
					reject('unable_to_get_notes');
					return;
				}
			);
		} );
	}

	// This will send a fetch call to the server to get the latest notes.
	get_notes_from_server() {

		return new Promise( (resolve, reject) => {

			var postData = new FormData();
			postData.append('action', tip_jar_wp_note_wall_vars.get_notes_endpoint );
			postData.append('form_id', this.props.form_id );
			postData.append('notes_per_page', this.state.notes_per_page );
			postData.append('current_page', this.state.current_page );
			postData.append('get_notes_nonce', tip_jar_wp_note_wall_vars.get_notes_nonce);

			fetch( tip_jar_wp_note_wall_vars.get_notes_endpoint, {
				method: "POST",
				mode: "same-origin",
				credentials: "same-origin",
				body: postData
			} ).then(
				( response ) => {
					if ( response.status !== 200 ) {
						console.log('Looks like there was a problem. Status Code: ' + response.status);
						reject('unable_to_get_notes');
						return;
					}

					// Examine the text in the response
					response.json().then(
						( data ) => {
							if ( data.success ) {

								this.setState( {
									notes: data.notes,
								} );

							} else {
								console.log('Looks like there was a problem: ' + data);
								reject('unable_to_get_notes');
								return;
							}
						}
					).catch(
						( err ) => {
							console.log('Fetch Error: ', err);
							reject('unable_to_get_notes');
							return;
						}
					);
				}
			).catch(
				( err ) => {
					console.log('Fetch Error: ', err);
					reject('unable_to_get_notes');
					return;
				}
			);

		} );

	}

	render_notes( notes, originalNote = null ) {
		var mapper = [];

		// Loop through each column
		for (var key in notes) {
			//if ( ! originalNote ) {
				originalNote = notes[key];
			//}
			mapper.push(
				<div key={ key } scope="col" className="tip-jar-wp-thread-container">
					<div className="tip-jar-wp-note-col-1">
						<div className="tip-jar-wp-note-callout">
							<div className="tip-jar-wp-note-badge">🚀</div>
							<div className="tip-jar-wp-note-avatar"><img src={ notes[key]['user_avatar'] } /></div>
						</div>
					</div>
					<div className="tip-jar-wp-note-col-2">
						<div className="tip-jar-wp-note-container">
							<div className="tip-note-intro-statement">
								<span className="tip-jar-wp-note-display-name">{ notes[key]['display_name'] }</span>
								<span className="tip-jar-wp-note-middlefix">{ ' sent a tip for ' }</span>
								<span className="tip-jar-wp-note-amount">{
									tip_jar_wp_format_money(
										notes[key]['amount'],
										notes[key]['currency'],
										notes[key]['is_zero_decimal_currency'],
										''
									)
								}</span>
								<span className="tip-jar-wp-note-middlefix">{ ' to ' }</span>
								<span className="tip-jar-wp-note-creator-name">{ tip_jar_wp_note_wall_vars.creator_display_name }</span>
							</div>
							<div className="tip-jar-wp-note-text">{ notes[key]['note_content'] }</div>
							{ this.render_reply_button( notes[key], key, originalNote ) }
						</div>
						{ this.render_reply_creator( notes[key], key ) }
						<div className="tip-note-replies">
							{(() => {
								if ( notes[key]['replies'] ) {
									return (
										this.render_replies( notes[key]['replies'], originalNote )
									);
								}
							})()}
						</div>
					</div>
				</div>
			);
		}

		return mapper;
	}

	render_replies( notes, originalNote ) {
		var mapper = [];

		// Loop through each column
		for (var key in notes) {
			mapper.push(
				<div key={ key } scope="col" className="tip-jar-wp-thread-container">
					<div className="tip-jar-wp-note-col-1">
						<div className="tip-jar-wp-note-callout">
							<div className="tip-jar-wp-note-avatar"><img src={ notes[key]['user_avatar'] } /></div>
						</div>
					</div>
					<div className="tip-jar-wp-note-col-2">
						<div className="tip-jar-wp-note-container">
							<div className="tip-note-intro-statement">
								<span className="tip-jar-wp-note-display-name">{ notes[key]['display_name'] }</span>
							</div>
							<div className="tip-jar-wp-note-text">{ notes[key]['note_content'] }</div>
							{ this.render_reply_button( notes[key], key, originalNote ) }
						</div>
						{ this.render_reply_creator( notes[key], key ) }
						<div className="tip-note-replies">
							{(() => {
								if ( notes[key]['replies'] ) {
									return (
										this.render_replies( notes[key]['replies'], originalNote )
									);
								}
							})()}
						</div>
					</div>
				</div>
			);
		}

		return mapper;
	}

	check_if_user_is_logged_in() {

		var this_component = this;

		var postData = new FormData();
		postData.append( 'action', 'tip_jar_wp_check_if_user_logged_in' );
		postData.append( 'tip_jar_wp_check_if_user_logged_in', true );

		// Check if this user is logged in, and set the state of "Manage Payments" accordingly
		fetch( tip_jar_wp_js_vars.ajaxurl + '?tip_jar_wp_check_if_user_logged_in', {
			method: "POST",
			mode: "same-origin",
			credentials: "same-origin",
			body: postData
		} ).then(
			function( response ) {
				if ( response.status !== 200 ) {

					this_component.props.main_component.setState( {
						user_logged_in: null
					} );

					console.log('Looks like there was a problem. Status Code: ' + response.status);

					return;
				}

				// Examine the text in the response
				response.json().then(
					function( data ) {
						if ( data.success ) {

							this_component.props.main_component.setState( {
								user_logged_in: data.user_logged_in,
								frontend_nonces: data.frontend_nonces ? data.frontend_nonces : this_component.props.main_component.state.frontend_nonces
							} );

						} else {

							// Remove the user ID from the main state and set the state to be login
							this_component.props.main_component.setState( {
								user_logged_in: null,
								frontend_nonces: data.frontend_nonces ? data.frontend_nonces : this_component.props.main_component.state.frontend_nonces
							} );
						}
					}
				).catch(
					function( err ) {

						// Remove the user ID from the main state and set the state to be login
						this_component.props.main_component.setState( {
							user_logged_in: null
						} );

						console.log('Fetch Error: ', err);
					}
				);
			}
		).catch(
			function( err ) {

				// Remove the user ID from the main state and set the state to be login
				this_component.props.main_component.setState( {
					user_logged_in: null
				} );

				console.log('Fetch Error :-S', err);
			}
		);
	}

	render_reply_button( note_parent, note_key, originalNote ) {
		console.log( 'sgsdgsd' );

		if ( ! tip_jar_wp_note_wall_vars.user_is_logged_in ) {
			return(
				<div className="tip-note-replies">
					<a
						className="tip-jar-wp-note-reply-button"
						onClick={ this.open_login_prompt.bind( this, note_parent, note_key ) }
					>
						{ originalNote['display_name'] + ' or ' + tip_jar_wp_note_wall_vars.creator_display_name + ' can log in to reply' }
					</a>
					{ (() => {
						if ( this.state.render_login_prompt ) {
							return (
								<div className="tip-jar-wp-payment-form-container">
									<div className="tip-jar-wp-payment-box-view">
										<Tip_Jar_WP_Login
											main_component={ this }
											check_if_user_is_logged_in={ this.props.check_if_user_is_logged_in }
										/>
									</div>
								</div>
							)
						}
					})()}
				</div>
			)
		}

		if ( ! note_parent.user_can_reply ) {
			return '';
		}


			return(
				<React.Fragment>
					<div className="tip-note-replies">
						<a
							className="tip-jar-wp-note-reply-button"
							onClick={	this.set_note_reply_state.bind( this, note_parent, note_key ) }
						>
							REPLY
						</a>
					</div>
				</React.Fragment>
			);

	}

	open_login_prompt() {
		this.setState( {
			render_login_prompt: true
		})
	}

	render_reply_creator( note_parent, note_key ) {

		if ( ! note_parent.user_can_reply ) {
			return '';
		}

		// If we should show the reply button, show it.
		// The way we decide that is if the currently-set-to-reply field's parent does not matches the parent of the reply field being rendered...
		if ( this.state.note_parent.id !== note_parent.id ) {
			return( '' );

			// If this note should have the reply input showing, show it.
		} else {
			return(
				<div className="tip-note-replies">
					{ this.render_reply_input( note_parent, note_key ) }
				</div>
			);
		}
	}

	render_reply_input( note_parent, note_key ) {

		// If the currently-set-to-reply field's parent matches the parent of the reply field being rendered...
		if ( this.state.note_parent.id !== note_parent.id ) {
			return '';
		}

		// And if the currently-set-to-reply field's looping key matches the looping key of the field being rendered...
		if ( this.state.note_key !== note_key ) {
			return '';
		}

		if ( this.state.reply_input_visible ) {
			return(
				<React.Fragment>
					<div key={ note_key } scope="col" className="tip-jar-wp-thread-container">
						<div className="tip-jar-wp-note-col-1">
							<div className="tip-jar-wp-note-callout">
								<div className="tip-jar-wp-note-avatar"><img src={ tip_jar_wp_note_wall_vars.current_user['user_avatar'] } /></div>
							</div>
						</div>
						<div className="tip-jar-wp-note-col-2">
							<div className="tip-jar-wp-note-container">
								<div className="tip-note-intro-statement">
									<span className="tip-jar-wp-note-display-name">{ tip_jar_wp_note_wall_vars.current_user['display_name'] }</span>
								</div>
								<div className="tip-jar-wp-note-text">
									<textarea
										ref={(input) => { this.reply_input = input; }}
										onChange={ this.hande_note_update.bind( this ) }
									/>
									<button
										type="submit"
										className="tip-jar-wp-note-reply-button"
										onClick={ this.hande_note_submit.bind( this ) }
									>
										REPLY
									</button>
									<button
										type="button"
										className="tip-jar-wp-note-reply-button"
										onClick={	this.cancel_note_reply_state.bind( this ) }
									>
										CANCEL
									</button>
								</div>
							</div>
						</div>
					</div>
				</React.Fragment>
			);
		} else {
			return '';
		}
	}

	render() {
		if ( this.state.notes.length > 0 ) {
			return (
				<div className="tip-jar-wp-notes-container">
					<div className="tip-jar-wp-notes-title-tabs">
						<div className="tip-jar-wp-note-title-tab tip-jar-wp-note-title-tab-active">{ "Latest Tips" }</div>
					</div>
					<div className="tip-jar-wp-notes">
						{ this.render_notes( this.state.notes ) }
					</div>
				</div>
			);
		} else {
			return'';
		}
	}
}

// Load a single note component.
window.tip_jar_wp_refresh_note_wall = function tip_jar_wp_refresh_note_wall( tip_jar_wp_note_wall_element, form_id ) {
	ReactDOM.render( <Tip_Jar_WP_Note_Wall
		form_id={ form_id }
	/>, tip_jar_wp_note_wall_element );

	return false;
}

// Find and load all note components on the page.
window.tip_jar_wp_refresh_all_note_wall_elements = function tip_jar_wp_refresh_all_note_wall_elements() {

	var tip_jar_wp_note_wall_elements = document.querySelectorAll( '.tip-jar-wp-note-wall' );

	// Loop through each Tip Jar WP element on the page
	tip_jar_wp_note_wall_elements.forEach(function( tip_jar_wp_note_wall_element ) {
		var form_id = tip_jar_wp_note_wall_element.getAttribute( 'tipjarwp_form_id');
		tip_jar_wp_refresh_note_wall( tip_jar_wp_note_wall_element, form_id );
	} );
}
tip_jar_wp_refresh_all_note_wall_elements();

// Create an event listener for when the editing mode changes for the payment form.
var satt_editing_mode_change = new Event('satt_editing_mode_change');

// Make the body visibility set to "visible" once all of the react from tip jar wp has loaded.
document.addEventListener( 'tip_jar_wp_rendered', () => {
	document.getElementById( 'sendatiptobody' ).classList.add("sendatiptobodyvisible");
} );

// Set up a timer which fires the event after 3 seconds so that is the longest wait.
setTimeout( function() {
	document.dispatchEvent( new Event('tip_jar_wp_rendered') );
}, 1000 );
